<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="agentname"
      placeholder="输入代理商名称进行查找"
      ref="searchBar"
    />
    <div class="filter-bar" @click="select">
      <span>
        年份 {{ year }}
        <i class="caret"></i>
      </span>
    </div>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.agentid"
        :to="{name: 'AgentPerformance', params: {item}}"
      >
        <div class="weui-cell__bd">
          <p>{{item.agentname}}</p>
          <p class="list-item-muted">{{item.agentcode}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'#,##0.'">{{item.yearamount}}</p>
          <p class="list-item-muted">{{item.defaultcurrency}}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'#,##0.'">{{getTotal('yearamount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList
  },
  mixins: [list],
  data() {
    var year = new Date().getFullYear()
    return {
      listUrl: "/api/agent/report/agentYJ",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 99999,
      },
      year,
    }
  },
  methods: {
    select() {
      var me = this,
        year = new Date().getFullYear(),
        years = []
      for (let i = year - 20, len = year + 20; i <= len; i++) {
          years.push({
              value: i,
              label: i + "年"
          });
      }
      me.$weui.picker(
        years,
        {
          title: "选择年份",
          onConfirm: function (r) {
            me.year = r[0].value
            me.onSearch()
          },
        }
      );
    },
    getCondition() {
      var me = this,
        condition = [
          {"type":"string","field":"y","operation":"like","value":me.year}
        ],
        searchBar = me.$refs.searchBar,
        searchCondition = searchBar ? searchBar.getCondition() : null;
      if (searchCondition) {
        condition.push(searchCondition);
      }
      return condition;
    },
  }
}
</script>

<style scoped>
.filter-bar {
  background: var(--weui-BG-2);
  position: relative;
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
}
.filter-bar span {
  margin: 0 auto;
}
</style>